import { FC } from 'react'
import { Table, Button } from 'antd'
import { useParams, useNavigate } from 'react-router'
import { LeftOutlined } from '@ant-design/icons'
import { PageSpinner, Title } from '@signifyd/components'
import { toTitleCase } from '@signifyd/utils'
import { useDashboardParams } from 'core/queryParams/useDashboardParams'
import { useGetRuns } from 'lib/queries/useGetRuns/useGetRuns'
import { getColumns } from './utils'

const CiRuns: FC = () => {
  const {
    query: { suite },
  } = useDashboardParams()
  const navigate = useNavigate()
  const { projectName } = useParams<{
    projectName: string
  }>()

  const { data, isLoading } = useGetRuns({ suite, project: projectName })

  if (!projectName) {
    return null
  }

  if (isLoading) {
    return <PageSpinner />
  }

  const navPrefix = `?suite=${suite}`

  return (
    <>
      <Button icon={<LeftOutlined />} onClick={() => navigate(`/playwright`)}>
        All projects latest runs
      </Button>
      <Title level={3}>{toTitleCase(projectName)} CI test runs</Title>
      {data && (
        <Table
          columns={getColumns(projectName, navPrefix)}
          dataSource={data}
          rowKey="runId"
          pagination={{ position: ['bottomCenter'], defaultPageSize: 30 }}
        />
      )}
    </>
  )
}

export default CiRuns
